<template>
  <div class="columns document-container">
    <div class="column">
      <div class="document">
        <match-history-header/>
        <es-loader
          v-if="loading"
          style="margin: 6.5rem"
        />
        <es-exception
          v-else-if="loadingError"
          exceptionMessage="There was an issue. Please try again or contact your administrator."
        />
        <router-view
          v-else
          name="matchHistoryResults"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import EsLoader from '@/components/EsLoader.vue';
import EsException from '@/components/EsException.vue';
import MatchHistoryHeader from '@/views/PersonId/MatchHistory/MatchHistoryHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';

export default {
  mixins: [
    BreadcrumbsManager,
  ],
  components: {
    EsLoader,
    EsException,
    MatchHistoryHeader,
  },
  created() {
    this.setBreadcrumb([
      { text: 'Home', to: { name: 'personId' } },
      { text: 'Match History', to: { } },
    ]);
    this.onLoad();
  },
  data() {
    return {
      loading: true,
      loadingError: null,
    };
  },
  methods: {
    ...mapActions('lookups', [
      'loadPidSchoolYears',
      'loadPersonTypes',
    ]),
    async onLoad() {
      try {
        await Promise.all([
          this.loadPidSchoolYears(),
          this.loadPersonTypes(),
        ]);
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
